import { useCallback, useState } from 'react'

// Quản lý theme sáng/tối. Nguồn sự thật = class `.dark` trên <html> + localStorage.
// Init class đã chạy ở index.html (tránh nháy trắng); hook chỉ đồng bộ React state
// + cho phép toggle. Mặc định = dark. KHÔNG đụng logic nghiệp vụ.

export type Theme = 'light' | 'dark'

const KEY = 'theme'

function currentTheme(): Theme {
  // Mặc định dark khi không có DOM (an toàn cho non-browser); trình duyệt thì
  // đọc class `.dark` do script no-flash ở index.html set.
  if (typeof document === 'undefined') return 'dark'
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

function applyTheme(theme: Theme): void {
  const root = document.documentElement
  root.classList.toggle('dark', theme === 'dark')
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // localStorage có thể bị chặn (private mode) — bỏ qua, vẫn áp class.
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(currentTheme)

  // Mặc định = dark (không theo prefers-color-scheme nữa). State khởi tạo đã
  // đúng nhờ class `.dark` script no-flash ở index.html set sẵn; chỉ đổi khi
  // user bấm toggle. Không cần lắng nghe OS.

  const setTheme = useCallback((next: Theme) => {
    applyTheme(next)
    setThemeState(next)
  }, [])

  const toggle = useCallback(() => {
    setTheme(currentTheme() === 'dark' ? 'light' : 'dark')
  }, [setTheme])

  return { theme, setTheme, toggle }
}
